import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'
import { isEmpty } from 'lodash'
import { Modal, Input, Button, Table } from '@driftt/tide-core-legacy'

import { fetchOrgTeams, createOrgTeam } from 'app/modules/teams/actions'
import { createTeamSucceeded, createTeamFailed } from 'app/modules/teams/selectors'

import app from 'containers/app'
import RowFormatter from './RowFormatter'
import AddTeamMembers from 'components/settings/team/AddTeamMembers'

import './style.styl'

const UserColumns = [
  {
    label: 'Members',
    value: 'user',
  },
]

class CreateTeamModal extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      teamName: '',
      teamMembers: [],
      showAddMembers: false,
      isSaving: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { createTeamFailed, createTeamSucceeded, actions, onCancelTeamCreate } = this.props

    if (prevProps.createTeamFailed !== createTeamFailed) {
      onCancelTeamCreate()
      this.sendCreateTeamFailedNotification()
    }

    if (prevProps.createTeamSucceeded !== createTeamSucceeded) {
      onCancelTeamCreate()
      actions.fetchOrgTeams()
      this.sendCreateTeamSucceededNotification()
    }
  }

  onCancelClick = () => {
    this.props.onCancelTeamCreate()
  }

  onTeamNameChange = e => {
    const value = e.target.value
    this.setState({ teamName: value })
  }

  hideAddMembersModal = () => {
    this.setState({ showAddMembers: false })
  }

  showAddMembers = () => {
    this.setState({ showAddMembers: true })
  }

  updateTeamMembers = teamMembers => {
    this.setState({ teamMembers })
    this.hideAddMembersModal()
  }

  removeTeamMember = memberToRemove => {
    const membersClone = [...this.state.teamMembers]
    this.setState({ teamMembers: membersClone.filter(member => member.id !== memberToRemove.id) })
  }

  saveTeam = () => {
    const { actions } = this.props
    const { teamMembers, teamName } = this.state

    this.setState({
      isSaving: true,
    })
    setTimeout(() => {
      actions.createOrgTeam({
        team: {
          name: teamName,
          members: teamMembers.map(member => member.id),
        },
      })
    }, 500)
  }

  renderTeamButtonContent = () => {
    return 'Create team'
  }

  sendCreateTeamFailedNotification = () => {
    app.actions.NotificationActions.pushNotification({
      variant: 'red',
      content: 'We failed to save your team. Please try again or contact support for help.',
    })
  }

  sendCreateTeamSucceededNotification = () => {
    const { teamName } = this.state

    app.actions.NotificationActions.pushNotification({
      content: `Your team "${teamName}" has successfully been added!`,
    })
  }

  renderCreateTeamContent = () => {
    const { teamName, teamMembers, isSaving } = this.state
    const isTeamListEmpty = teamMembers.length === 0
    return (
      <div className="team-modal-content-container">
        <h2 className="team-modal-header">Create a new team</h2>
        <div className="team-modal-content">
          <h4 className="team-modal-search-header">Team name</h4>
          <Input
            className="team-name-modal-input"
            placeholder="Team name"
            value={teamName}
            onChange={this.onTeamNameChange}
          />
          <div className="member-container">
            <div className="teammates-info">
              <p className="teammates-stat">{teamMembers.length} {teamMembers.length === 1 ? 'teammate' : 'teammates'}</p>
            </div>
            <div className="user-filter">
              <Button
                type="utility"
                className="add-members-button"
                icon="user-add"
                iconAlignment="left"
                onClick={this.showAddMembers}
              >
                Add teammates
              </Button>
            </div>
          </div>
          <Table
            className={cx('team-users-table', { empty: isTeamListEmpty })}
            columns={UserColumns}
            data={RowFormatter({
              members: teamMembers,
              onMemberDelete: this.removeTeamMember,
            })}
          />
          {isTeamListEmpty && <div className="team-users-empty">No teammates (yet!)</div>}
        </div>
        <div className="team-name-modal-button-container">
          <Button
            disabled={isEmpty(teamName) || isEmpty(teamMembers) || isSaving}
            loading={isSaving}
            onClick={this.saveTeam}
          >
            {this.renderTeamButtonContent()}
          </Button>
          <Button type="tertiary" onClick={this.onCancelClick}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const { teamMembers, showAddMembers } = this.state

    return (
      <Modal
        className="add-members-modal"
        open={true}
        size="medium"
        onClose={this.onCancelClick}
      >
        {!showAddMembers && this.renderCreateTeamContent()}
        {showAddMembers && (
          <AddTeamMembers
            onCancel={this.hideAddMembersModal}
            teamMembers={teamMembers}
            onSave={this.updateTeamMembers}
            onBackLinkClick={this.hideAddMembersModal}
          />
        )}
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  createTeamFailed: createTeamFailed(state),
  createTeamSucceeded: createTeamSucceeded(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchOrgTeams,
      createOrgTeam,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateTeamModal)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/CreateTeamModal/index.js